/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    var contentCms = {
        template: '<span ng-bind-html="text"></span>',
        bindings: { identifier: '@' },
        controller: contentCmsController
    };

    angular
        .module('askApp')
        .component('contentCms', contentCms);

    contentCmsController.$inject = ['Content', '$sce', '$scope'];

    function contentCmsController(Content, $sce, $scope) {
        var vm = this;
        this.$onInit = function () {
            Content.get({id: vm.identifier}, onSuccess, onError);

            function onSuccess(data) {
                $scope.text = $sce.trustAsHtml(data.text);
            }
            function onError(error) {
                //console.log(error);
            }
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('askApp')
        .directive('loadScript', function() {
            return function(scope, element, attrs) {
                angular.element('<script src="http://www.marinetraffic.com/js/embed.js"></script>').appendTo(element);
            }
        });
})();
